import React from "react";
import {
  Alert,
  Box,
  MenuItem,
  Select,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import UploadArea from "./UploadArea";
import PromptField from "./PromptField";

export default function KlingMotionControlFormPanel({ form, onChange, lang, categoryId, modelId }) {
  const set = (patch) => onChange({ ...form, ...patch });

  return (
    <Stack spacing={2.5}>
      <Alert severity="info" sx={{ py: 0.5 }}>
        {lang?.videoStudioMotionControlHint ||
          "Transfer motion from a reference video onto your character image. Requires exactly one portrait image and one motion video (MP4/MOV)."}
      </Alert>

      <UploadArea
        lang={lang}
        label={lang?.videoStudioMotionCharacterImage || "Character image"}
        hint={lang?.videoStudioMotionCharacterImageHint || "One portrait — JPEG/PNG, max 10MB"}
        files={form.imageUrlUploads || []}
        onChange={(imageUrlUploads) => set({ imageUrlUploads })}
        maxFiles={1}
      />

      <UploadArea
        lang={lang}
        kind="video"
        accept="video/mp4,video/quicktime,.mp4,.mov"
        maxBytes={100 * 1024 * 1024}
        label={lang?.videoStudioMotionRefVideo || "Motion reference video"}
        hint={lang?.videoStudioMotionRefVideoHint || "MP4/MOV, max 100MB — drives the action"}
        files={form.referenceVideoUploads || []}
        onChange={(referenceVideoUploads) => set({ referenceVideoUploads })}
        maxFiles={1}
      />

      <Box>
        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.75}>
          {lang?.videoStudioCharacterOrientation || "Character orientation"}
        </Typography>
        <ToggleButtonGroup
          exclusive
          size="small"
          value={form.characterOrientation || "image"}
          onChange={(_, v) => v && set({ characterOrientation: v })}
        >
          <ToggleButton value="image">{lang?.videoStudioOrientImage || "Follow image"}</ToggleButton>
          <ToggleButton value="video">{lang?.videoStudioOrientVideo || "Follow video"}</ToggleButton>
        </ToggleButtonGroup>
      </Box>

      <Box>
        <Typography variant="caption" color="text.secondary" fontWeight={600} display="block" mb={0.75}>
          {lang?.videoStudioResolution || "Resolution"}
        </Typography>
        <Select
          size="small"
          value={form.motionResolution || "720p"}
          onChange={(e) => set({ motionResolution: e.target.value })}
        >
          <MenuItem value="720p">720p</MenuItem>
          <MenuItem value="1080p">1080p</MenuItem>
        </Select>
      </Box>

      <PromptField
        form={form}
        onChange={onChange}
        lang={lang}
        modelId={modelId || form.model}
        textFieldProps={{ minRows: 2, placeholder: lang?.videoStudioMotionPromptOptional || "Scene prompt (optional)" }}
      />
    </Stack>
  );
}
